"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeFilterEnd = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const DateTimeFilter_1 = tslib_1.__importDefault(require("../DateTimeFilter"));
/**
 * Wrapper used to provide different defaultProps for "to" start/end DateTimeFilter
 */
const DateTimeFilterEnd = (props) => {
    const themeProps = (0, styles_1.useThemeProps)({
        props,
        name: "DateTimeFilterEnd",
    });
    return react_1.default.createElement(DateTimeFilter_1.default, { ...themeProps });
};
exports.DateTimeFilterEnd = DateTimeFilterEnd;
exports.default = exports.DateTimeFilterEnd;
